import Loading from "./Loading";

function ApiValidate({ children, isLoading, isError, error }) {
  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return error?.response?.data?.message || "Something went wrong";
  }

  return children;
}

export default ApiValidate;
